import DetectRTC from "detectrtc";

export interface IMediaDevicesStatus {
  isWebsiteHasMicrophonePermissions: boolean;
}

export class MediaDevicesService {
  public readonly mediaDevicesStatus: IMediaDevicesStatus;

  constructor() {
    this.mediaDevicesStatus = { isWebsiteHasMicrophonePermissions: false };
  }

  reloadPermissions(): Promise<IMediaDevicesStatus> {
    return new Promise<IMediaDevicesStatus>((resolve) => {
      DetectRTC.load(() => {
        this.mediaDevicesStatus.isWebsiteHasMicrophonePermissions =
          DetectRTC.isWebsiteHasMicrophonePermissions;
        resolve(this.mediaDevicesStatus);
      });
    });
  }
}

export const mediaDevicesService = new MediaDevicesService();
